import React, { useState } from 'react';
import './index.less';
import * as util from "../../../src/utils/index";

const App = () => {
  const [formData, setFormData] = useState({
    name: '',
    version: '',
    env: 'daily',
  });
  const [statusMessage, setStatusMessage] = useState(''); // 用来存储状态消息
  const [isSubmitting, setIsSubmitting] = useState(false); // 用来标记是否正在提交

  // 环境下拉框选项
  const environments = ['daily'];

  // 表单提交处理
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // 设置正在提交
    let {name, version, env} = formData;
    let newName = name.replace(/\s+/g, "");
    let newVer = version.replace(/\s+/g, "");
    let res = await util.post('/npm/changeTne2ndVersion', {name: newName, version: newVer, env});
    setIsSubmitting(false); // 提交完成，重置状态
    if(res.success){
        setStatusMessage('变更成功!');
    }else{
        setStatusMessage(res.message);
    }
    // 你可以在这里做其他处理，如发送到后端 API 等
  };

  // 更新表单数据
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="moblie-form-container">
      <h1>版本变更</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">包名</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="请输入包名"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="version">版本号</label>
          <input
            type="text"
            id="version"
            name="version"
            value={formData.version}
            onChange={handleChange}
            placeholder="请输入版本号"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="env">环境</label>
          <select
            id="env"
            name="env"
            value={formData.env}
            onChange={handleChange}
            required
            disabled
          >
            {environments.map((env) => (
              <option key={env} value={env}>
                {env}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? '提交中...' : '提交'}
          </button>
        {/* 显示状态消息 */}

      </form>
      {statusMessage && (
          <div className={`status-message ${!statusMessage.includes('变更成功!') ? 'error' : 'success'}`}>
            {statusMessage}
          </div>
        )}
    </div>
  );
};

export default App;
